import React from "react";
import { Navigate } from "react-router-dom";
import { readStoredIsSubscription } from "../hooks/useSidebarData";

const PublicRoute = ({ children }) => {
  const user = localStorage.getItem("linko_web");
  const queryString = window.location.search;

  // If coming back from Stripe payment via query params, redirect to /plans with params
  if (queryString && (queryString.includes("success") || queryString.includes("fail"))) {
    return <Navigate to={`/plans${queryString}`} />;
  }

  // If returning from Stripe (flag persisted before redirect)
  if (localStorage.getItem("stripe_pending")) {
    localStorage.removeItem("stripe_pending");
    return <Navigate to="/plans?success" />;
  }

  // If the user is authenticated, redirect to a protected page
  if (user) {
    const isSub = readStoredIsSubscription();
    if (isSub) {
      return <Navigate to="/chat" />;
    }
    return <Navigate to="/plans" state={{ tab: "plans" }} />;
  }

  // If not authenticated, allow access to the public page (e.g., login)
  return children;
};

export default PublicRoute;
